<template>
  <v-select v-model="value" :placeholder="$vuetify.lang.t('$vuetify.map.criticalPopup.retrainStates.noneSelected')" :label="label"
            :items="items" :error-messages="isStateEmpty ? errors : []"></v-select>
</template>

<script>
import Vuetify from '../../../../plugins/vuetify'
import { RetrainingState } from '../../../../enum'

export default {
  name: 'retrainStates',
  props: {
    isStateEmpty: Boolean,
    label: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    value: null
  }),
  computed: {
    errors () {
      return [Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.retrainStates.emptyStateError`)]
    },
    items () {
      return Object.values(RetrainingState).map(item => ({
        value: item,
        text: Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.title.${item}`)
      }))
    }
  },
  methods: {
    resetForm () {
      this.value = null
    }
  },
  watch: {
    value (value) {
      this.$emit('state-changed', value)
    }
  }
}
</script>

<style scoped>

</style>
